import { toast } from "sonner";

/**
 * Manda o usuário pro serviço externo de onboarding/ (handoff via token
 * assinado). O fluxo interno antigo foi descontinuado — só existe o
 * onboarding externo agora, então isso depende de ONBOARDING_APP_URL e
 * ONBOARDING_JWT_SECRET estarem configurados no servidor.
 */
export async function goToOnboarding() {
  try {
    const res = await fetch("/api/onboarding-handoff");
    if (res.ok) {
      const data = await res.json();
      if (data.redirect && data.url) {
        window.location.href = data.url;
        return;
      }
    }
  } catch {
    // segue pro aviso abaixo
  }
  toast.error("Onboarding indisponível no momento. Tente novamente em instantes.");
}

/** Reabre a sugestão de antes/depois já gerada, sem refazer o onboarding. */
export async function goToOnboardingReview() {
  try {
    const res = await fetch("/api/onboarding-handoff?review=1");
    if (res.ok) {
      const data = await res.json();
      if (data.redirect && data.url) {
        window.location.href = data.url;
        return;
      }
    }
  } catch {
    // sem serviço externo configurado — não há pra onde revisar
  }
  toast.error("Não foi possível abrir sua sugestão agora. Tente novamente em instantes.");
}
